import React from "react";

import EditShop from "shopAdminViews/editShop/EditShop";
import logo from "assets/img/sparkLoginLogo.svg";
import "./standalonePage.css";

/**
 * ShopEditShop - the standalone "your shop needs changes" page.
 *
 * Sign-in sends a rejected shop straight here rather than into the
 * dashboard, so this is a page in its own right and not a panel
 * screen. The inner EditShop renders bare when `editAfterRejection` is
 * set and leaves the frame to this file; EditShopForm shows whatever
 * the reviewer said needs fixing.
 */
const ShopEditShop = () => (
  <div className="standalonePage">
    <div className="standaloneInner isWide">
      <div className="standaloneBrand">
        <img src={logo} alt="Spark" />
      </div>

      <div className="standaloneHead">
        <h1 className="standaloneTitle">Your shop needs a few changes</h1>
        <p className="standaloneSubtitle">
          Update the details below and we will take another look.
        </p>
      </div>

      <div className="standaloneCard">
        <EditShop editAfterRejection={true} theme="superAdmin" type="shopAdmin" />
      </div>
    </div>
  </div>
);

export default ShopEditShop;
